// The parts of viewTheme (./theme.ts) that are the app's LOOK for a chart and a card, kept in a module with no
// imports and no build-time environment so the artifact kit's generator (scripts/gen-artifact-kit.ts) reads
// the same values the renderers do: an agent's hand-drawn SVG and a card on its page then carry the app's
// line weight, axis type, grid tone, palette and card chrome (owner, 3 Nov 2026: "it just needs the feel of
// the app"). viewTheme spreads these in; renderers keep reading viewTheme.

export const CHART_LOOK = {
  bar: { fillClass: 'fill-primary' },
  line: { strokeClass: 'stroke-primary', strokeWidth: 2 },
  /** Zero baseline drawn on cartesian charts whose y-domain crosses zero (SEN-1326 sign fix). */
  baseline: { strokeClass: 'stroke-muted-foreground', strokeWidth: 1 },
  /** category labels under a bar / along an axis */
  axisLabel: { fontSize: 10, fillClass: 'fill-muted-foreground' },
  /** numeric/time axes: tick text and the horizontal gridlines */
  axis: {
    tickFontSize: 11,
    tickFillClass: 'fill-muted-foreground',
    gridStrokeClass: 'stroke-border',
    gridStrokeWidth: 1,
  },
  /** the unit over a chart's value axis ("kWh") */
  unitCaption: { className: 'px-1 text-xs text-muted-foreground' },
  /** a data value over its mark */
  valueLabel: { fontSize: 10, fillClass: 'fill-foreground' },
  /** Multi-series palette — the FALLBACK. A series bound to a record that
   *  carries its own `color` attribute (energy sources, SEU categories) is
   *  drawn in that colour first (see views/seriesColor.ts); the palette is
   *  for identities with no colour of their own (building types, countries).
   *  Index-cycled; six hues so six sources do not wrap. */
  series: {
    palette: [
      'hsl(var(--chart-1))', 'hsl(var(--chart-2))', 'hsl(var(--chart-3))',
      'hsl(var(--chart-4))', 'hsl(var(--chart-5))', 'hsl(var(--chart-6))',
    ],
  },
} as const

/** Card chrome around a widget on a `rows` dashboard — Sentinel's Card / CardHeader / CardTitle /
 *  CardDescription, class for class (SEN-433 §4.2), and the page rhythm around them. */
export const CARD_LOOK = {
  /** Rows sit 24px apart (Sentinel's page rhythm, `space-y-6`). */
  rowsClass: 'flex min-w-0 flex-col gap-6',
  /** a row of self-framed figures (the KPI row): the summary grid rule (`rowGridClass`) + this gap */
  rowsFramedRowClass: 'gap-4',
  cardClass: 'group relative flex min-w-0 flex-col rounded-lg border bg-card text-card-foreground',
  cardHeaderClass: 'flex flex-col space-y-1.5 p-6 pb-3',
  cardHeaderRowClass: 'flex items-center justify-between',
  /** Sentinel's CardTitle is `cn('font-semibold leading-none tracking-tight', 'text-lg …')`, and
   *  tailwind-merge drops `leading-none` for text-lg's own line height (28px): the class as it renders */
  cardTitleClass: 'font-semibold tracking-tight text-lg flex items-center gap-2',
  cardSubtitleClass: 'text-sm text-muted-foreground',
  cardBadgeClass: 'inline-flex items-center rounded-sm border px-2.5 py-0.5 font-semibold transition-colors text-foreground text-xs',
  cardBodyClass: 'min-h-0 p-6 pt-0',
  cardBodyEdgeClass: 'min-h-0 p-0',
} as const

/** THE summary grid rule (SEN-433, A20): as many equal columns of at least 11rem as fit, collapsing
 *  empty tracks — a collection summary's row and a dashboard's row of self-framed cards. */
export const SUMMARY_ROW_GRID_CLASS = 'grid min-w-0 [grid-template-columns:repeat(auto-fit,minmax(11rem,1fr))]'
